import React from 'react'
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import OverViewIcon from "../../Icons/OverViewIcon";
import loadable from "@loadable/component";

const ExcelTemplateComponent = loadable(
  () => import("../../components/ExcelTemplate/TemplateList")
);

const ExcelTemplateList = () => {
  return (
    <>
     <div
            className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
          >
            <OverViewIcon />
            <span className={tw`text-[#5E5757] font-bold text-xl`}>
             Excel Template
            </span>
          </div>
          <ExcelTemplateComponent/>
    </>
  )
}

export default ExcelTemplateList